import React, { lazy } from "react";
import { Route } from "react-router-dom";
import { ProtectedRoute, RoleGuard } from "@shared/components";

const ClientsPage = lazy(() => import("./pages/ClientsPage"));
const ClientDetail = lazy(() => import("./pages/ClientDetail"));
const MySessionsPage = lazy(() => import("./pages/MySessionsPage"));

/**
 * Route definitions for the Gateway module.
 *
 * The Clients section is restricted to admin+tm: read-only roles (user/viewer)
 * are redirected by `RoleGuard`. The gateway also 403s them server-side, so this
 * is UX only.
 */
export const gatewayRoutes = [
    <Route
        key="clients"
        path="/clients"
        element={
            <ProtectedRoute>
                <RoleGuard requiredRoles={["admin", "tm"]}>
                    <ClientsPage />
                </RoleGuard>
            </ProtectedRoute>
        }
    />,
    <Route
        key="client-detail"
        path="/clients/:clientId"
        element={
            <ProtectedRoute>
                <RoleGuard requiredRoles={["admin", "tm"]}>
                    <ClientDetail />
                </RoleGuard>
            </ProtectedRoute>
        }
    />,
    <Route key="my-sessions" path="/mes-sessions" element={<ProtectedRoute><MySessionsPage /></ProtectedRoute>} />,
];
